import EATable from "../../EATable";
import React from "react";
import {createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {useHttp} from "../../../services/HttpService";
import {getMessstelleUebersichtEndpoint} from "../../../services/Messstellenservice";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {createCustomTextLink} from "../../../utils/RouteUtils";
import {MESSSTELLE} from "../../../consts/fachobjekt";
import {useHistory} from "react-router-dom";

export default function MessstellenUebersicht(props) {
    const history = useHistory();
    const [{data, loading}] = useHttp(getMessstelleUebersichtEndpoint(props.match.params.anlageid));

    const linkColumnComponentProvider = (row) => createCustomTextLink(row.messstellenId, MESSSTELLE, row.id, history);

    const columns = [
        createComponentColumn("messstellenId", linkColumnComponentProvider, "Messstellen-Nr."),
        createColumn("bezeichnung", "Messstelle"),
        createColumn("messstellentyp.value", "Messstellentyp"),
        createColumn("messstellenstatus.value", "Status")
    ];

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <EATable columns={columns} data={data} loading={loading}/>
            </EABetriebsakteMainContainer>
        </div>
    );
}
